import levels_1_2 from './level_1_2';
import levels_3_4 from './level_3_4';
import levels_5_6 from './level_5_6';
import levels_7_8 from './level_7_8';
import levels_9_10 from './level_9_10';
import levels_11_12_13 from './level_11_12_13';
import levels_14_15_16 from './level_14_15_16';
import levels_17_18 from './level_17_18';

const LEVELS_DATA = [
  ...levels_1_2,
  ...levels_3_4,
  ...levels_5_6,
  ...levels_7_8,
  ...levels_9_10,
  ...levels_11_12_13,
  ...levels_14_15_16,
  ...levels_17_18,
];

export default LEVELS_DATA;
